<div class="container home-container">
  @if (showError) {
    <div class="row">
      <div class="error-msg">
        <!-- <div id="error-head">
        <span><img src="assets/errorIcon.png" /></span
          ><span>Invalid digits</span>
        </div> -->
        <p id="error-description">
          {{ contentfulData?.errorMessage?.content }}
        </p>
      </div>
    </div>
  }
  <div class="row">
    <p class="home-header">{{ page_content?.title }}</p>
  </div>
  <div class="home-text-div">
    <div class="row">
      <p class="home-text" innerHTML="{{ subtitle }}">
        <!-- You have the option to accept the full credit limit increase, or a
        lesser amount based on your needs. The choice is yours! -->
      </p>

    </div>
    <div class="row">
      <p class="home-text">
        {{ contentfulData?.secondPara?.content }}
        <!-- To begin, please enter the last 4-digits of your Rogers Bank Mastercard
        card number and follow the steps. -->
      </p>
    </div>

    <div class="row four-digit-code">
      <div class="col-md-4">
        <div class="form">
          <form [formGroup]="verifyForm">
            <div class="floating">
              <input
                id="input__username"
                class="floating__input"
                name="last-four-digits"
                formControlName="lastFourDigits"
                type="text"
                placeholder="Last 4-digits for credit card"
                maxlength="4"
                minlength="4"
                pattern="[0-9]+"
                (keypress)="numberOnly($event)"
                [ngClass]="{
                  'not-valid': showError
                }"
                [ngClass]="{
                  'is-invalid': submitted
                }"
                (focusout)="errorFunction()"
                />

                <label
                  for="input__username"
                  class="floating__label"
                  [attr.data-content]="contentfulData?.placeHolderText?.content"
                  >
                </label>

                @if (submitted && f['lastFourDigits'].errors) {
                  <div class="invalid-feedback">
                    @if (f['lastFourDigits'].errors['required']) {
                      <span id="min-len-field">{{ contentfulData?.errorMessage2?.content }}</span>
                      } @if (f['lastFourDigits'].errors['minlength']) {
                      <div>{{ contentfulData?.errorMessage1?.content }}</div>
                      } @if (f['lastFourDigits'].errors['pattern']) {
                      <div>{{ contentfulData?.errorMessage1?.content }}</div>
                    }
                  </div>
                } @else if(f['lastFourDigits'].errors){ @if
                  (f['lastFourDigits']['touched'] && f['lastFourDigits']['status']
                  == 'INVALID') {
                  <div class="invalid-feedback" style="color: red">
                    {{ contentfulData?.errorMessage1?.content }}
                  </div>
                  } }
                </div>
              </form>
            </div>

            <!-- <span id="form-group-error-message" *ngIf="showError"
            ><img src="assets/errorIcon2.png" alt="error-icon" />Invalid
            digits</span
            > -->
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <button type="button" class="btn verify-button" (click)="onSubmit()">
              {{ contentfulData?.verifyButton?.label }}
            </button>
          </div>
        </div>
      </div>
    </div>
